// extracted by mini-css-extract-plugin
export default {"emptyRoot":"ev96Zvzf1La9fFvDtpjY","orderItem":"mnLFQ0BOMm30C7WAUlcf","placeHolderShimmer":"iL2n8CjAUeS7bvtpfOVN"};